import { CLIENT_EVENT_CODES } from "../constants/clientEventCode";

export type ClientEventCode = (typeof CLIENT_EVENT_CODES)[number];

export const isValidClientEventCode = (value: unknown): value is ClientEventCode =>
  CLIENT_EVENT_CODES.includes(value as ClientEventCode);
